import * as React from 'react';
import Iframe from './page/iframe';
import Img from './page/img';
import Dom from './page/dom';
import { offset } from './page/type';

export default function ({path, onDrag, onWheel}: {
    path: string,
    onDrag: (offset: offset) => void,
    onWheel?: (e: WheelEvent) => void,
}) {
    if (isDom(path)) {
        return <Dom path={path} onDrag={onDrag} onWheel={onWheel}/>;
    } else if (isHtml(path)) {
        return <Iframe path={path} onDrag={onDrag} onWheel={onWheel}/>;
    } else {
        return <Img path={path} onDrag={onDrag} onWheel={onWheel}/>;
    }
}

function isHtml(path: string) {
    return path.toLowerCase().endsWith('.html') || path.toLowerCase().endsWith('.htm');
}

function isDom(path: string) {
    return isHtml(path) && path.toLowerCase().includes('.dom.');
}
